import { Component } from '@angular/core';

@Component({
  selector: 'app-one-column-layout',
  templateUrl: './one-column-layout.component.html',
})
export class OneColumnLayoutComponent { }
